import { Languages } from "@/constants/languages";
import { Routes as AppRoutes } from "@/constants/routes";
import i18n from "@/localization/i18next";
import {
    readLanguageHintForInit,
    resolvePsgRedeemDisplayLanguage,
} from "@/localization/psgRedeemLanguage";

const switchLanguage = () => {
    if (window.location.pathname.startsWith(`/${AppRoutes.Both}/${AppRoutes.Mex}`)) {
        i18n.changeLanguage(Languages.Spanish);
    }
    if (window.location.pathname.includes(AppRoutes.RedeemPSGCode)) {
        const hint =
            (typeof i18n.language === "string" && i18n.language) || readLanguageHintForInit();
        void i18n.changeLanguage(resolvePsgRedeemDisplayLanguage(hint));
    }
};

export default switchLanguage;
